export default "__VITE_ASSET__BrNj2qjN__"